<template>
    <div>
        <redesign-base-popover trigger="click">
            <template #reference>
                <div class="cursor-pointer text-blue-600 underline">
                    {{ 'JSON' }}
                </div>
            </template>
            <pre>{{ formatted }}</pre>
        </redesign-base-popover>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'

const props = defineProps<{ value: string }>()


const formatted = computed(() => {
    try {
        return JSON.stringify(JSON.parse(props.value), null, 2)
    } catch {
        return props.value
    }
})
</script>
